import React from "react";
import Formulario from "../../components/Formulario/Formulario";
import Footer from "../../components/Footer/Footer";
import Portada from "../../components/Portada/Portada";
import "./Contacto.css";

function Contacto() {
  return (
    <div className="background-c">
      <Portada titulo="Contacto" />
      <Formulario />
      <Footer />
    </div>
  );
}

export default Contacto;
